import { IframeMessageType } from '~/apps/product-plus/pages/gz/types';

type DataLayerEvent = {
  [key: string]: unknown;
  event: string;
  eventLabel?: string;
};

declare global {
  interface Window {
    dataLayer: DataLayerEvent[];
  }
}

export const trackEvent = (event: string, data: Record<string, unknown>) => {
  if (typeof window !== 'undefined') {
    // GZ iframe context: drop events if consent not granted
    if (window.iframeGZContext && window.iframeGZContext.consentGranted !== true) {
      return;
    }

    const cleanData = Object.fromEntries(Object.entries(data).filter(([_, value]) => value !== undefined));

    const eventPayload: DataLayerEvent = {
      event,
      eventLabel: (data.eventLabel as string | undefined) ?? '',
      ...cleanData,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);

    if (window.parentIFrame) {
      window.parentIFrame.sendMessage({ type: IframeMessageType.GTM_EVENT, data: eventPayload });
    }
  }
};
